import "./ScheduleView.scss";
import { useDispatch, useSelector } from "react-redux";
import UnifiedControlPlaneService from "../../UnifiedControlPlane.service";
import CurrentScheduleView from "./CurrentScheduleView";
import ScheduleListView from "./ScheduleListView";
import SingleScheduleView from "./SingleScheduleView";
import { ReactComponent as GenerateSchedulelistIcon } from "../../assets/raw/GenerateSchedulelist.svg";
import { ReactComponent as CurrentScheduleIcon } from "../../assets/raw/GenerateSchedule.svg";
import { setShowReviewSchedulePopup } from "../../../../store/UnifiedControlPlaneSlice";

const ScheduleView = ({ mission_id, scenarioId }) => {
  const dispatch = useDispatch();

  const showReviewSchedulePopup = useSelector(
    (state) => state.unifiedControlPlane.showReviewSchedulePopup
  );

  const fetchOrderAssignments = (schedule) => {
    dispatch(
      UnifiedControlPlaneService.getOrderAssignments(
        mission_id,
        schedule.scheduleId
      )
    );
  };

  const showSchedule = () => {
    if (showReviewSchedulePopup === "current-schedule") {
      dispatch(setShowReviewSchedulePopup(""));
    } else {
      dispatch(
        UnifiedControlPlaneService.getCurrentSchedule(
          mission_id,
          fetchOrderAssignments
        )
      );
      dispatch(setShowReviewSchedulePopup("current-schedule"));
    }
  };

  const showScheduleList = () => {
    if (showReviewSchedulePopup === "list-schedule") {
      dispatch(setShowReviewSchedulePopup(""));
    } else {
      dispatch(UnifiedControlPlaneService.getAllSchedules(mission_id));
      dispatch(setShowReviewSchedulePopup("list-schedule"));
    }
  };

  const scheduleViewProps = {
    mission_id,
    scenarioId,
  };

  return (
    <>
      {showReviewSchedulePopup === "current-schedule" && (
        <CurrentScheduleView {...scheduleViewProps} />
      )}
      {showReviewSchedulePopup === "list-schedule" && (
        <ScheduleListView {...scheduleViewProps} />
      )}
      {showReviewSchedulePopup === "single-schedule" && (
        <SingleScheduleView {...scheduleViewProps} />
      )}
      <>
        <div
          className={
            showReviewSchedulePopup?.length !== 0
              ? "ucpFeaturesBar scheduleBar scheduleBarOpen"
              : "ucpFeaturesBar scheduleBar scheduleBarClose"
          }
          style={{ width: "auto" }}
        >
          <div className="schedule-actions">
            <button
              className={`schedule-btn current-schedule-btn ${
                showReviewSchedulePopup === "current-schedule" ? "active" : ""
              }`}
              onClick={() => showSchedule()}
            >
              <CurrentScheduleIcon />
              <span className="ucpTooltip">Current Schedule</span>
            </button>
            <div className="gradient-border"></div>
            <button
              className={`schedule-btn all-schedule-btn ${
                showReviewSchedulePopup === "list-schedule" ||
                showReviewSchedulePopup === "single-schedule"
                  ? "active"
                  : ""
              }`}
              onClick={() => showScheduleList()}
            >
              <GenerateSchedulelistIcon />
              <span className="ucpTooltip">All Schedules</span>
            </button>
          </div>
        </div>
      </>
    </>
  );
};

export default ScheduleView;
